import { render } from "./table_projects.vue?vue&type=template&id=4e602aca"
import script from "./table_projects.vue?vue&type=script&lang=js"
export * from "./table_projects.vue?vue&type=script&lang=js"

import "./table_projects.vue?vue&type=style&index=0&id=4e602aca&lang=css"

import exportComponent from "C:\\Projekty\\Adaste\\vue-app\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__